@import '../../styles/calendar.css';
@import '../../styles/buttons.css';

:host {
  display: block;
  display: flex;
  flex-direction: column;

  --slot-height: 30px;
}

.slot-time-wrapper {
  width: 30px;
}

.slot-time-wrapper .time {
  font-weight: 400;
  margin-top: 5px;
  font-size: 12px;
  line-height: 14px;
  overflow-wrap: normal;
}

.space-card-slots {
  display: flex;
  overflow: scroll;
  user-select: none;
  gap: 5px;
  scrollbar-width: none;
  margin-right: 1px;
  padding: 0 20px;
}

.space-card-slots::-webkit-scrollbar {
  display: none;
}

.space-card-slots .slot {
  flex-shrink: 0;
  width: 30px;
  height: var(--slot-height);
  padding: 5px;
  border: 1px solid #ddd;
}

.space-card-slots .slot .card-plus {
  opacity: 0;
  width: 12px;
  height: 12px;
  color: #dcdcdc;
}

.space-card-slots .slot.available.selectable:hover .card-plus {
  opacity: 1;
}

.slots-outer-container {
  position: relative;
  margin: auto 0 0;
  box-sizing: border-box;
}

.slots-outer-container::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 10%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient( to right, rgba(255, 255, 255, 0), white 30px );
  opacity: 0;
  transition: opacity 0.2s ease;
}

.slots-outer-container.right-scroll::after {
  opacity: 1;
}

.slots-outer-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 10%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient( to left, rgba(255, 255, 255, 0), white 30px );
  opacity: 0;
  transition: opacity 0.2s ease;
}

.slots-outer-container.left-scroll::before {
  opacity: 1;
}

.slots-legend {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 12px;
  column-gap: 20px;
  row-gap: 10px;
  flex-wrap: wrap;
  padding: 20px 20px;
}

.slot-legend {
  display: flex;
  gap: 5px;
  align-items: center;
}

.slot-legend[hidden] {
  visibility: hidden;
}

.slot-legend .slot {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  padding: 5px;
  border: 1px solid #ddd;
  pointer-events: none;
}

.slot-legend .slot.not-available {
  background-size: unset;
  background-image: repeating-linear-gradient( 45deg, #ddd 0, #ddd 1px, #f8f8f8 0, #f8f8f8 30% );
}

.slot-legend .slot.current-user-order {
  background-image: repeating-linear-gradient( 45deg, var(--tambr-accent-color, #000000) 0, var(--tambr-accent-color, #000000) 1px, #f8f8f8 0, #f8f8f8 30% );
}

.tambr-arrow-button {
  --arrow-button-size: 30px;
  position: absolute;
  top: 0;
  transition: visibility 0.1s ease-in-out, opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

.left-button { 
  left: -5px; 
}

.right-button { 
  right: -5px; 
}

.left-button.visible, .right-button.visible {
  visibility: visible;
  opacity: 1;
}

.left-button.hidden, .right-button.hidden {
  visibility: hidden;
  opacity: 0;
}

.left-button.hidden {
  transform: translateX(20%);
}

.right-button.hidden {
  transform: translateX(-20%);
}